import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Link
} from 'components'
import React, { useMemo } from 'react'

import SectionContent from '../../components/SectionContent'
import SectionHeader from '../../components/SectionHeader'
import SectionLayout from '../../components/SectionLayout'
import { faqData } from '../../data/faq'

const FaqSection = () => {
  const spliceFaqData = useMemo(() => faqData.slice(0, 3), [])
  return (
    <SectionLayout>
      <SectionHeader className="text-3xl sm:text-4xl">
        Frequently Asked Questions
        <span className="text-primary text-6xl">?</span>
      </SectionHeader>
      <SectionContent className="flex-col w-full max-w-5xl mx-auto">
        <Accordion
          type="single"
          collapsible
          className="w-full flex flex-col gap-5">
          {spliceFaqData.map((obj) => (
            <AccordionItem value={obj.id} key={obj.id}>
              <AccordionTrigger className="text-left">
                {obj.question}
              </AccordionTrigger>
              <AccordionContent>{obj.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="flex flex-col items-center mt-5">
          <Link href="/pages/new-faq" className="text-primary font-semibold">
            View all
          </Link>
        </div>
      </SectionContent>
    </SectionLayout>
  )
}

export default FaqSection
